import { useState } from "react";
import { notifications } from "@mantine/notifications";

interface EmailForm {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export const useEmailForm = () => {
  const [form, setForm] = useState<EmailForm>({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (field: keyof EmailForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const submit = async () => {
    const webhookUrl = import.meta.env.VITE_CONTACT_WEBHOOK_URL;
    if (!webhookUrl) {
      notifications.show({
        title: "Configuration Error",
        message: "Contact form is not configured yet.",
        color: "red",
      });
      setError(true);
      return;
    }

    setLoading(true);
    setSuccess(false);
    setError(false);

    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      notifications.show({
        title: "Message Sent!",
        message: "Thanks for reaching out. I'll get back to you soon.",
        color: "green",
      });
      setSuccess(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      notifications.show({
        title: "Error",
        message: "Something went wrong. Please try again or email me directly.",
        color: "red",
      });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { form, handleChange, submit, loading, success, error };
};
